import type { SuretyWinnerProspect } from "@/types/surety";

// ---- PESTAÑAS DE PROSPECTOS ----
// "Ganaron" es la lista completa del mes; las demás la filtran. Las de prospectos
// dejan fuera a los clientes, que tienen la suya. Las usan el Mercado y la tarjeta
// "Para descubrir" del Panel, para que los dos cuenten lo mismo.

export type ProspectTab = "winners" | "clients" | "partners" | "frequent" | "lookalikes";

export const PROSPECT_TABS: {
  id: ProspectTab;
  label: string;
  hint: string;
  matches: (row: SuretyWinnerProspect) => boolean;
}[] = [
  {
    id: "winners",
    label: "Ganaron",
    hint: "Lo que se ganó en el mes, sin las contrataciones menores. Las de tus clientes, solos o en consorcio, van marcadas. Las que todavía no firman necesitan su garantía en días.",
    matches: () => true,
  },
  {
    id: "clients",
    label: "Tus clientes",
    hint: "Lo que ganaron tus clientes en el mes, solos o en consorcio. Si no firmaron, necesitan su garantía en días.",
    matches: (row) => row.isClient,
  },
  {
    id: "partners",
    label: "Socios de tus clientes",
    hint: "El ganador, o un integrante de su consorcio, ya se consorció con un cliente tuyo: tu cliente te puede presentar.",
    matches: (row) => !row.isClient && !!row.partnerOf,
  },
  {
    id: "frequent",
    label: "Postores frecuentes",
    hint: "Presentaron 5 o más ofertas en los últimos 6 meses: postulan seguido y van a necesitar más fianzas. Solo hay datos de obras y consultorías.",
    matches: (row) => !row.isClient && row.isFrequentBidder,
  },
  {
    id: "lookalikes",
    label: "Parecidas a tus clientes",
    hint: "Ganaron solas en la región y el objeto donde ganan tus clientes, y no tienen sanciones vigentes.",
    matches: (row) => !row.isClient && !!row.likeClient,
  },
];

export const prospectTab = (id: ProspectTab) =>
  PROSPECT_TABS.find((tab) => tab.id === id)!;
